import React from "react";

const SignOff: React.FC = () => {
    return <h5 style={{textAlign: "right", marginBottom: 0}}>syntaxlabco.</h5>
}

export default SignOff
